/** @jsx jsx */
import { jsx } from 'theme-ui';



const Banner = (props) => (
  <div
    sx={{
      margin: '0 auto',
      width: '100%',
      textAlign: 'center',
      '> p': {
        padding: '3rem 0',
        margin: 0,
      },
    }}
    {...props}
  />
);

export default Banner;